import { Box, Column, Text } from '~/commonComponents';
import { IPostingPlanViewEntity } from '~/domain/PermanentJobs';
import { Colors } from '~/themes/colors';

interface IPaymentDetailsPreviewProps {
  plan?: IPostingPlanViewEntity;
}

export const PaymentDetailsPreview = ({ plan }: IPaymentDetailsPreviewProps) => {
  const price = plan?.finalPrice ? plan.finalPrice.toFixed(2) : '-';

  return (
    <Box gap={14}>
      <Text fontSize={22} bold>
        Payment
      </Text>

      <Box
        paddingTop={22}
        paddingBottom={32}
        paddingHorizontal={63}
        border={`1.5px solid ${Colors.neutral_100}`}
        borderRadius={8}
      >
        <Column gap={18}>
          <Box
            backgroundColor={Colors.neutral_50}
            borderRadius={3}
            paddingVertical={12}
            paddingHorizontal={17}
          >
            <Text fontSize={15}>
              You’ll be charged when your job is posted, and your listing will renew monthly unless
              you choose to cancel.
            </Text>
          </Box>

          <Box
            paddingTop={22}
            paddingBottom={32}
            paddingHorizontal={25}
            boxShadow="0 2px 4px rgba(0, 0, 0, 0.15), 0 2px 4px rgba(0, 0, 0, 0.15)"
            borderRadius={10}
          >
            <Text fontSize={18} bold color="secondary_500">
              Job Posting Fee
            </Text>
            <Text fontSize={14} color="neutral_500">
              <Text fontSize={36} bold color="neutral_600">
                ${price}
              </Text>{' '}
              /monthly
            </Text>
            <Text fontSize={15} italic marginTop={10}>
              Your job will be active and visible to candidates.
            </Text>
          </Box>
        </Column>
      </Box>
    </Box>
  );
};
